import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Sheet } from '@paypalcorp/pp-react-sheet';
import { HeadingText, BodyText } from '@paypalcorp/pp-react-text';
import DropzoneImageHandle from './DropzoneImageHandle';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';

const ImageModal = ({
  getContent,
  isOpen,
  handleCloseModal,
  dispatch,
  uploadImage,
  bannerImageUrl,
  isMobile,
}) => {
  const title = getContent('modal.title');
  const body = getContent('modal.body');
  const bullets = getContent('modal.bullet');

  useEffect(() => {
    if (isOpen) {
      trackEventWithData(FPTI_SPEC.UPLOAD_BACKGOURND_IMG_MODAL_IM);
    }
  }, [isOpen]);

  const handleDismissClick = () => {
    trackEventWithData(FPTI_SPEC.UPLOAD_BACKGOURND_IMG_MODAL_DISMISS_CL);
    handleCloseModal();
  };

  return (
    <Sheet
      id="image-banner-modal"
      className="image-banner-modal"
      isOpen={isOpen}
      onClose={handleDismissClick}
      hideTitle={true}
    >
      <HeadingText className="banner-modal-title" size="lg">
        {title}
      </HeadingText>
      <BodyText>
        {body}
        <ul>
          <li>{bullets[0]}</li>
          <li>{bullets[1]}</li>
          <li>{bullets[2]}</li>
        </ul>
      </BodyText>
      <DropzoneImageHandle
        dispatch={dispatch}
        getContent={getContent}
        uploadImage={uploadImage}
        closeModal={handleCloseModal}
        bannerImageUrl={bannerImageUrl}
        isMobile={isMobile}
      />
    </Sheet>
  );
};

ImageModal.propTypes = {
  getContent: PropTypes.func,
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  dispatch: PropTypes.func,
  uploadImage: PropTypes.func,
  bannerImageUrl: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default ImageModal;
